module.exports = __webpack_public_path__ + "img/SC.fc8b1936.svg";